/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

export enum CARD_FIELD_NAMES {
  paymentCreditCard = 'paymentCreditCard',
  nameOnCard = 'nameOnCard',
  expMonth = 'expMonth',
  expYear = 'expYear',
  CVV = 'CVV',
  captcha = 'captcha'
}

export enum ADDRESS_FIELD_NAMES {
  firstName = 'firstName',
  lastName = 'lastName',
  countryId = 'countryId',
  stateId = 'stateId',
  city = 'city',
  postalCode = 'postalCode',
  address1 = 'address1',
  phoneNumber = 'phoneNumber',
}

export const MODAL_UPDATE_ADDRESS = 'updatedBillingAddress'
